// extracted by mini-css-extract-plugin
export default {"container":"Um_6gHBiAVhMPWflkCb9","content":"eY_eXq9ZKzL6xU_kcIFS"};